import { render } from "./JoinForm.vue?vue&type=template&id=fb9bc4ca&scoped=true"
import script from "./JoinForm.vue?vue&type=script&lang=js"
export * from "./JoinForm.vue?vue&type=script&lang=js"

import "./JoinForm.vue?vue&type=style&index=0&id=fb9bc4ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb9bc4ca"

export default script